// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3ET7i","box":"WorkspacesBox_box__1AxSK","node":"WorkspacesBox_node__3UvY_"};